import React, { useEffect, useState, useContext } from "react";
import CenterSearchModal from "../Utils/CenterSearchModal";
import BeneficiaryModal from "../Utils/BeneficiaryModal";
import { ProfileContext, NurseDataContext, BeneficiariesContext } from "../../contexts";

const ProfileEdit = () => {
  const { profile, setProfile, updateProfile } = useContext(ProfileContext);
  const { nurseData: editedNurseData, setNurseData: setEditedNurseData, addNurseData, deleteNurseData, updateNurseData } = useContext(NurseDataContext);
  const { beneficiariesData: editedBeneficiaries, setBeneficiariesData: setEditedBeneficiaries, addBeneficiary, deleteBeneficiary, updateBeneficiary } = useContext(BeneficiariesContext);

  const [selectedNurseData, setSelectedNurseData] = useState(null);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState(null);
  const [modals, setModals] = useState({
    centerSearch: false,
    beneficiary: false,
  });
  const toggleModal = (modalName, value) => {
    setModals((prev) => ({ ...prev, [modalName]: value }));
  };
  const [searchResults] = useState({});

  const [editedProfile, setEditedProfile] = useState(profile || {});


  useEffect(() => {
    if (profile) {
      setEditedProfile(profile);
      setEditedNurseData(profile.nurse_data);
      setEditedBeneficiaries(profile.beneficiaries);
    }
  }, [profile]);

  // const handleChange = (e) => {
  //   setProfile({ ...profile, [e.target.name]: e.target.value });
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   fetch(`${API_URLS.API_PROFILE_URL}users/me/`, {
  //     method: "PUT",
  //     headers: { "Content-Type": "application/json", Authorization: `Token ${token}` },
  //     body: JSON.stringify(profile),
  //   })
  //     .then((res) => res.json())
  //     .then((data) => alert("프로필이 수정되었습니다."));
  // };

  const handleNurseDataSave = (data) => {
    if (!data.specialization) {
      alert("전문분야를 입력하세요.");
      return;
    }

    if (!data.selectedCenter) {
      alert("센터를 입력하세요.");
      return;
    }

    const newEntry = { specialization: data.specialization, center_id: data.selectedCenter.id };

    (data?.id !== undefined && data.id >= 0) ? updateNurseData(data.id, newEntry) : addNurseData(newEntry);

    toggleModal("centerSearch", false);
  };

  const openNurseDataModal = (nurseData) => {
    const { center, ...rest } = nurseData || {}; // center 필드 제외, 추가 시에는 {}로 초기화
    setSelectedNurseData({
      ...rest,
      center_title: center?.title || "",  // center modal에서 title을 center_title로 변경
    });
    toggleModal("centerSearch", true);
  };

  const openBeneficiaryModal = (beneficiary) => {
    setSelectedBeneficiary(beneficiary); // 수정할 데이터 or null(새 추가)
    toggleModal("beneficiary", true);
  };

  const handleBeneficiarySave = (data) => {
    if (!data.name) {
      alert("이름을 입력하세요.");
      return;
    }

    if (!data.birth_date) {
      alert("생년월일을 입력하세요.");
      return;
    }

    if (!data.phone_num_1st) {
      alert("연락처를 입력하세요.");
      return;
    }

    const { name, birth_date, phone_num_1st } = data;
    const gender = ["남자", "남성", "남", "M", "MALE"].includes(data.gender) ? "MALE" : "FEMALE";
    const newEntry = {
      name, birth_date, gender, phone_num_1st
    };

    (data?.id !== undefined && data.id >= 0) ? updateBeneficiary(data.id, newEntry) : addBeneficiary(newEntry);

    toggleModal("beneficiary", false);
  };

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setEditedProfile((prev) => ({ ...prev, [name]: value }));
  };

  const handleProfileUpdate = () => {
    updateProfile(editedProfile);
  };

  return (
    <section className="py-5">
      <div className="container px-5">
        <div className="bg-light rounded-4 py-5 px-4 px-md-5">
          <div className="text-center mb-5">
            <img className="mb-4" src="/assets/images/widus-logo.png" alt="" width="100" />
            <h1 className="fw-bolder">프로필 수정</h1>
          </div>
          <div className="row gx-5 justify-content-center">
            <div className="col-lg-8 col-xl-6">

              <div className="form-floating mb-3">
                <input type="text" className="form-control" id="username" value={editedProfile.username || ""} disabled />
                <label htmlFor="username">사용자계정</label>
              </div>

              <div className="form-floating mb-3">
                <input type="text" className="form-control" id="name" name="name" value={editedProfile.name || ""} onChange={handleProfileChange} required />
                <label htmlFor="name">이름</label>
                <div className="invalid-feedback" data-sb-feedback="name:required">A name is required.</div>
              </div>

              <div className="form-floating mb-3">
                <input type="text" className="form-control" id="email" name="email" value={editedProfile.email || ""} onChange={handleProfileChange} />
                <label htmlFor="email">이메일</label>
                <div className="invalid-feedback">이메일 형식으로 입력하세요(Email is not valid).</div>
              </div>

              <div className="form-floating mb-3">
                <input type="text" className="form-control" id="phone_num_1st" name="phone_num_1st" value={editedProfile.phone_num_1st || ""} onChange={handleProfileChange} required />
                <label htmlFor="phone_num_1st">전화번호 1</label>
              </div>

              <div className="form-floating mb-3">
                <input type="text" className="form-control" id="phone_num_2nd" name="phone_num_2nd" value={editedProfile.phone_num_2nd || ""} onChange={handleProfileChange} />
                <label htmlFor="phone_num_2nd">전화번호 2</label>
              </div>

              <div className="form-floating mb-3">
                <input type="text" className="form-control" id="address_1st" name="address_1st" value={editedProfile.address_1st || ""} onChange={handleProfileChange} />
                <label htmlFor="address_1st">도로명 주소</label>
              </div>

              <div className="form-floating mb-3">
                <input type="text" className="form-control" id="address_2nd" name="address_2nd" value={editedProfile.address_2nd || ""} onChange={handleProfileChange} />
                <label htmlFor="address_2nd">상세 주소</label>
              </div>

              <div className="mb-3">
                <input type="checkbox" checked={editedProfile.is_nurse} onChange={(e) => setEditedProfile({ ...editedProfile, is_nurse: e.target.checked })} /> 간호사 여부
              </div>

              {editedProfile.is_nurse && (
                <div>
                  <h5>간호사 정보</h5>
                  <div className="form-floating mb-3">
                    <input type="date" className="form-control" id="birth_date" name="birth_date" value={editedProfile.birth_date || ""} onChange={handleProfileChange} />
                    <label htmlFor="birth_date">생년월일</label>
                  </div>
                  <div className="form-floating mb-3">
                    <select className="form-control" id="gender" name="gender" value={editedProfile.gender || ""} onChange={handleProfileChange}>
                      <option value="MALE">남성</option>
                      <option value="FEMALE">여성</option>
                    </select>
                    <label htmlFor="gender">성별</label>
                  </div>
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <h5>소속 센터</h5>
                    <button type="button" className="btn" onClick={() => openNurseDataModal(null)}><i className="bi bi-plus-square"></i></button>
                  </div>
                  {(editedNurseData||[]).map((item) => (
                    <div key={item.id} className="d-flex align-items-center gap-3 mb-3">
                      <div className="form-floating flex-grow-1">
                        <input type="text" className="form-control" id="specialization" name="specialization" value={item.specialization} />
                        <label htmlFor="specialization">전문분야</label>
                      </div>
                      <div className="form-floating flex-grow-1">
                        <input type="text" className="form-control" id="center_title" name="center_title" value={item.center.title} />
                        <label htmlFor="center_title">근무 센터</label>
                      </div>
                      <button type="button" className="btn" onClick={() => openNurseDataModal(item)}><i class="bi bi-pencil-square"></i></button>
                      <button type="button" className="btn" onClick={() => deleteNurseData(item.id)}><i className="bi bi-trash"></i></button>
                    </div>
                  ))}
                  <CenterSearchModal
                    show={modals.centerSearch}
                    onClose={() => toggleModal("centerSearch", false)}
                    onSave={handleNurseDataSave}
                    searchResults={searchResults}
                    initialData={selectedNurseData}
                  />
                </div>
              )}
              <div>
                <div className="d-flex align-items-center gap-3 mb-3">
                  <h5>수혜자</h5>
                  <button type="button" className="btn" onClick={() => openBeneficiaryModal(null)}><i className="bi bi-plus-square"></i></button>
                </div>
                {(editedBeneficiaries||[]).map((item) => (
                  <div formArrayName="beneficiaries" className="d-flex align-items-center gap-3 mb-3">
                    <div className="form-floating flex-grow-1">
                      <input type="text" className="form-control" id="beneficiary" name="beneficiary" value={`${item.name}(${item.birth_date})`} />
                      <label htmlFor="beneficiary">이름(생년월일)</label>
                    </div>
                    <button type="button" className="btn" onClick={() => openBeneficiaryModal(item)}><i class="bi bi-pencil-square"></i></button>
                    <button type="button" className="btn" onClick={() => deleteBeneficiary(item.id)}><i className="bi bi-trash"></i></button>
                  </div>
                ))}
                <BeneficiaryModal
                  show={modals.beneficiary}
                  onClose={() => toggleModal("beneficiary", false)}
                  onSave={handleBeneficiarySave}
                  initialData={selectedBeneficiary}
                />

              </div>
            </div>
          </div>

          <button type="button" className="btn btn-primary mt-3" onClick={handleProfileUpdate}>저장</button>

        </div>
      </div>
    </section >

  );
};

export default ProfileEdit;
